import { render, staticRenderFns } from "./SortingLabel.vue?vue&type=template&id=42fc2f09"
import script from "./SortingLabel.vue?vue&type=script&lang=js"
export * from "./SortingLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports